import React from 'react';
import { Alert, Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';
import { fetchOfficialPpmReport, fetchOfficialPpmRows, fetchOfficialPpmSummary } from './ppmReportApi';
import { exportPpmRowsToExcel } from './ppmReportExport';

type State = { ppmId:number|''; report:any|null; rows:any[]; summary:any[]; loading:boolean; error:string; success:string; };

class PpmReportWorkbench extends React.Component<any, State> {
  state:State = { ppmId:'', report:null, rows:[], summary:[], loading:false, error:'', success:'' };

  columns: GridColDef[] = [
    { field:'psc', headerName:'Section', width:140 },
    { field:'acc', headerName:'Account', width:120 },
    { field:'acn', headerName:'Account Name', flex:1, minWidth:250 },
    { field:'bga', headerName:'Budget', width:140, renderCell:FGridMoneyCell },
    { field:'ara', headerName:'Arrears', width:120, renderCell:FGridMoneyCell },
    { field:'avc', headerName:'Available Credit', width:150, renderCell:FGridMoneyCell },
    { field:'atx', headerName:'Activity', flex:1, minWidth:300 },
    { field:'pnt', headerName:'Nature', width:180 },
    { field:'pmd', headerName:'Method', width:150 },
    { field:'rvt', headerName:'Review', width:120 },
    { field:'tpd', headerName:'Publication', width:140 },
    { field:'bsd', headerName:'Bid Deadline', width:140 },
    { field:'psd', headerName:'Start', width:130 },
    { field:'eed', headerName:'End', width:130 },
    { field:'lot', headerName:'Lot', width:100 },
    { field:'san', headerName:'Superactivity', width:180 },
  ];

  load = async () => {
    if (!this.state.ppmId) { this.setState({ error:'PPM ID is required.' }); return; }
    this.setState({ loading:true, error:'', success:'' });
    try {
      const [report, rows, summary] = await Promise.all([
        fetchOfficialPpmReport(Number(this.state.ppmId)),
        fetchOfficialPpmRows(Number(this.state.ppmId)),
        fetchOfficialPpmSummary(Number(this.state.ppmId)),
      ]);
      this.setState({ report, rows, summary, success:'PPM report loaded.' });
    } catch (err:any) { this.setState({ error:err.message || String(err) }); }
    finally { this.setState({ loading:false }); }
  };

  exportExcel = () => exportPpmRowsToExcel(this.state.rows, `ppm_${this.state.ppmId}.xlsx`);

  render() {
    const s = this.state;
    return (
      <Box sx={{ p:3 }}>
        <Stack spacing={3}>
          <Stack direction={{xs:'column', md:'row'}} justifyContent="space-between" alignItems={{xs:'stretch', md:'center'}} spacing={2}>
            <Box>
              <Typography variant="h4" sx={{fontWeight:700}}>Official PPM Report</Typography>
              <Typography variant="body2" color="text.secondary">Review and export official procurement plan format.</Typography>
            </Box>
            <Stack direction="row" spacing={1}>
              <TextField size="small" label="PPM ID" type="number" value={s.ppmId} onChange={(e)=>this.setState({ppmId:e.target.value === '' ? '' : Number(e.target.value)})} />
              <Button variant="outlined" startIcon={<RefreshIcon />} onClick={this.load} disabled={s.loading}>Load</Button>
              <Button variant="contained" startIcon={<FileDownloadIcon />} onClick={this.exportExcel} disabled={!s.rows.length}>Excel</Button>
            </Stack>
          </Stack>

          {s.error && <Alert severity="error">{s.error}</Alert>}
          {s.success && <Alert severity="success">{s.success}</Alert>}

          <FGrid title="PPM Report Rows" rows={s.rows} columns={this.columns} loading={s.loading} height={650} showQuickFilter getRowId={(r:any)=>r.rid||r.id} pageSizeOptions={[25,50,100]} initialState={{pagination:{paginationModel:{pageSize:25}}}} />
        </Stack>
      </Box>
    );
  }
}
export default PpmReportWorkbench;
